import axios from 'axios';
import API from '../config/API';

export const trustScoreService = {
    getTrustScore,
    saveTrustScore,
    updateTrustScore,
};

const headersApplicationJson = {
    'Content-Type': 'application/json',
};

function getTrustScore() {
    return axios.get(API.GET_TRUST_SCORE);
}

function saveTrustScore(params) {
    return axios.post(API.SAVE_TRUST_SCORE, params, {
        headers: headersApplicationJson,
    });
}

function updateTrustScore(params) {
    return axios.post(API.UPDATE_TRUST_SCORE, params, {
        headers: headersApplicationJson,
    });
}
